//LoanApplicationForm
import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../../Components/Atoms/Card/Card";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../../Components/Atoms/Button/Button";
import RadioButton from "../../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../../Components/Atoms/SingleDatePicker/SingleDatePicker";
import styles from "./LoanForm.module.scss";
import HBar from "../../Components/Bars/Bars";
import { useParams,useLocation } from 'react-router-dom';
import {getLoanApplicationDetailsApi,enquiry_details,get_user_details, get_master_data,updateLoanApplication,updateCustomerDetails,createAndupdateCustomerDetails} from "../../Enums/api_constunts"
import { postMethod } from "../../Helpers/services";
import _ from "lodash"
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
import SpeedometerComponent from "./SpeedometerComponent"
import {SalariedComponent} from "./SalariedComponent";
import {SenpComponent} from "./SenpComponent"
import { useNavigate } from "react-router-dom";
import {ObligationsChart} from "./ObligationsChart"
import moment from "moment";
import { OtherIncome } from "./OtherIncome";
export default function LoanApplicationForm({loanApplicationId,close_me,loaded_from='',enquiryData=null}) {
  const minAge =moment().subtract(18,"years").format("YYYY/MM/DD")

  const [loanapplicationform,setloanapplicationform] =useState(()=>loaded_from=="ENQUIRY_UPDATE_STATUS"?"loanapplicationform":"")
  
  const navigateTo = useNavigate()
  //const { loanApplicationId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  //const loanApplicationId = searchParams.get('loanApplicationId');

  //alert(loanApplicationId)
  const [isSpinner, setIsSpinner] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [ loanFormDetails, setLoanFormDetails] = useState(null)
  const [ enquiryDetails, setenquiryDetails] = useState(enquiryData)
  const [ proposed_emi, setproposed_emi] = useState(0)
  
  
  const getLoanApplicationDetails = ()=>{
    let postData ={"customer_id":loanApplicationId}
    //getLoanApplicationDetailsApi
    postMethod(get_user_details,postData).then((res)=>{
      
      setLoanFormDetails(_.get(res,"result"))
      
      
    }).catch ((error)=>{
      //showToast("error",_.get(error, "message","Something went wrong!"))
     

    })

  }
  const setDefaultValues = ()=>{
    //first_name
    if(_.has(loanFormDetails, "applicant_details.first_name")){
      formik.setFieldValue("first_name", loanFormDetails["applicant_details"]["first_name"])
    }
    //last_name
    if(_.has(loanFormDetails, "applicant_details.last_name")){
      formik.setFieldValue("last_name", loanFormDetails["applicant_details"]["last_name"])
    }

    //email
    if(_.has(loanFormDetails, "applicant_details.email")){
      formik.setFieldValue("email", loanFormDetails["applicant_details"]["email"])
    }

    //date_of_birth
    if(_.has(loanFormDetails, "applicant_details.date_of_birth")){
      formik.setFieldValue("date_of_birth", loanFormDetails["applicant_details"]["date_of_birth"])
    }

    //mobile_no
    if(_.has(loanFormDetails, "applicant_details.mobile_no")){
      formik.setFieldValue("mobile_no", loanFormDetails["applicant_details"]["mobile_no"])
    }

    //alternate_mobile_no
    if(_.has(loanFormDetails, "applicant_details.alternate_mobile_no")){
      formik.setFieldValue("alternate_mobile_no", loanFormDetails["applicant_details"]["alternate_mobile_no"])
    }

    //loanenquired
    
    if(_.has(loanFormDetails, "detail_of_service.name")){
     
      setSelectedServiceType(loanFormDetails["detail_of_service"]) 
      formik.setFieldValue("loanenquired", loanFormDetails["detail_of_service"]["name"])
    }else if(_.has(loanFormDetails, "applicant_details.detail_of_service.name")){
      
      setSelectedServiceType(loanFormDetails.applicant_details.detail_of_service) 
      formik.setFieldValue("loanenquired", loanFormDetails.applicant_details.detail_of_service["name"])
    }
    if(_.has(loanFormDetails, "loanAmount")){
     
      formik.setFieldValue("loanAmount", loanFormDetails["loanAmount"])
    }
    

    if(_.has(loanFormDetails, "lead_sourse_details.name")){
      setSelectedLeadSource(loanFormDetails["lead_sourse_details"]) 
      formik.setFieldValue("leadSource", loanFormDetails["lead_sourse_details"]["name"])
    }

    if(_.has(loanFormDetails, "profession_details.name")){
      setSelectedProfession(loanFormDetails["profession_details"]) 
      formik.setFieldValue("professionType", loanFormDetails["profession_details"]["name"])
    }
    if(_.has(loanFormDetails, "profession_sub_type_details.name")){
      setSelectedSubProfession(loanFormDetails["profession_sub_type_details"])
      formik.setFieldValue("sepType", loanFormDetails["profession_sub_type_details"]["name"])
    }
    if(_.has(loanFormDetails, "sepType")){
      
      formik.setFieldValue("sepType", loanFormDetails["sepType"]) }
    
    //selectedSubProfession,setSelectedSubProfession
    if(_.has(loanFormDetails, "companyName")){
      
      formik.setFieldValue("companyName", loanFormDetails["companyName"])
    }
    if(_.has(loanFormDetails, "designation")){
      formik.setFieldValue("designation", loanFormDetails["designation"])
    }
    if(_.has(loanFormDetails, "totalExperience")){
      formik.setFieldValue("totalExperience", loanFormDetails["totalExperience"])
    }
    if(_.has(loanFormDetails, "present_organization_years")){
      formik.setFieldValue("present_organization_years", loanFormDetails["present_organization_years"])
    }
    if(_.has(loanFormDetails, "workLocation")){
      formik.setFieldValue("workLocation", loanFormDetails["workLocation"])
    }
    if(_.has(loanFormDetails, "grossSalary")){
      formik.setFieldValue("grossSalary", loanFormDetails["grossSalary"])
    }
    if(_.has(loanFormDetails, "netSalary")){
      
      
      formik.setFieldValue("netSalary", loanFormDetails["netSalary"])
      setTotalSalaryNetIncome(loanFormDetails["netSalary"]);
    }
    if(_.has(loanFormDetails, "otherIncome")){
      
      formik.setFieldValue("otherIncome", loanFormDetails["otherIncome"]);
      setTotalOtherIncome(loanFormDetails["otherIncome"]);
    }
    if(_.has(loanFormDetails, "Obligations")){
      
      formik.setFieldValue("Obligations", loanFormDetails["Obligations"])
    }

    if(_.has(loanFormDetails, "eligible")){      
      formik.setFieldValue("eligible", loanFormDetails["eligible"])
    }
    if(_.get(loanFormDetails, "loan_eligible_type") >=1){
      let loan_eligible_type = serviceTypes.find((item)=>item.id==loanFormDetails["loan_eligible_type"])
      formik.setFieldValue("loan_eligible_type", _.get(loan_eligible_type,"label"))
    }
    if(_.has(loanFormDetails, "fdir")  ){
      
      formik.setFieldValue("fdir", !isNaN(loanFormDetails["fdir"]) ?loanFormDetails["fdir"]:"0%" )
    }
    if(_.has(loanFormDetails, "loan_eligible_amount") ){
      formik.setFieldValue("loan_eligible_amount", loanFormDetails["loan_eligible_amount"])
    }
    if(_.has(loanFormDetails, "proposed_emi") ){
      formik.setFieldValue("proposed_emi", loanFormDetails["proposed_emi"])
      setproposed_emi(loanFormDetails["proposed_emi"])
    }
    
    //eligible loan_eligible_type fdir loan_eligible_amount
    
   

  }

  useEffect(()=>{
    if(_.has(loanFormDetails, "applicant_details") || _.has(loanFormDetails, "id")){
      
      setDefaultValues();
    }
    
  },[loanFormDetails])

  
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
    
    let postData = {...values}
    postData["loan_application_form_id"] =  loanApplicationId
    postData["customer_id"] =  loanApplicationId
    //selectedServiceType ,selectedLeadSource  selectedProfession selectedSubProfession selectedIncomType
    if(_.get(selectedServiceType,"id")){
      postData["service_type_id"] = selectedServiceType["id"]
    }
    if(_.get(selectedLeadSource,"id")){
      postData["lead_sourse_id"] = selectedLeadSource["id"]
    }
    if(_.get(selectedProfession,"id")){
      postData["profession_type_id"] = selectedProfession["id"]
    }
    if(_.get(selectedSubProfession,"id")){
      postData["profession_sub_type_id"] = selectedSubProfession["id"]
    }
    if(_.get(selectedIncomType,"id")){
      postData["income_type_id"] = selectedIncomType["id"]
    }
    postData["all_obligations"] ="[]"
    if(_.get(values, "Obligations")=="Yes"){
      postData["all_obligations"] = JSON.stringify(values["obligationFields"])
    }
    
    if(_.get(values, "otherIncome")=="Yes"){
      postData["other_income_list"] = JSON.stringify(values["other_income_list"])
    }else{
      postData["all_obligations"] ="[]"
    }
    
    //updateCustomerDetails updateLoanApplication
    let url = updateCustomerDetails
    if(_.get(enquiryDetails,"id") && loaded_from=="ENQUIRY_UPDATE_STATUS"){
      url = createAndupdateCustomerDetails;
      postData["enquiry_id"] = enquiryDetails["id"];
    }
    if(_.get(postData,"date_of_birth")){

      postData["date_of_birth"] = moment(postData["date_of_birth"]).format("YYYY-MM-DD")
    }
    if(_.has(postData, "loan_eligible_type")){

      let loan_eligible_type = serviceTypes.find((item)=>item.id==postData["loan_eligible_type"] || item.label==postData["loan_eligible_type"] ) 
       if(_.has(loan_eligible_type,"id")){
        postData["loan_eligible_type"] = loan_eligible_type["id"]
       }
     
    }
    if(_.has(postData, "totalExperience")){
      postData["totalExperience"] = parseFloat(postData["totalExperience"])
    }
    if(_.has(postData, "present_organization_years")){
      postData["present_organization_years"] = parseInt(postData["present_organization_years"])
    }
    // postData["number_of_years"] = 0.0;
    // if(_.has(postData, "number_of_years")){
    //   postData["number_of_years"] = parseFloat(postData["number_of_years"])
    // }
    //number_of_years
    
    
    if(_.has(postData ,"number_of_years")){
      delete postData["number_of_years"]
    }
    
    postMethod(url,postData).then((res)=>{

      close_me(0)
      showToast("success",_.get(res, "message","Success"))
      getLoanApplicationDetails()
    }).catch((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false)
      //alert("ERROR")
    })
   
  }

  /*
  md_profession_sub_types
  md_lead_sources
    
  */
  const getMasterData = ()=>{
    let postData = {"categories":["md_lead_sources","md_profession_types","md_profession_sub_types","md_service_types","md_income_types","md_obligation_types"]};
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
        setLeadSourceList( _.get(res,"result.md_lead_sources",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        setProfessionList( _.get(res,"result.md_profession_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        if(_.get(res,"result.md_income_types.length",0)>0){
          setincomTypeList( _.get(res,"result.md_income_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        }
        
        setProfessionSubList( _.get(res,"result.md_profession_sub_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      
        if(_.get(res,"result.md_service_types",[])){

        let lst =  _.get(res,"result.md_service_types",[]);
        lst = lst.filter((item)=>item.id!=1)
        setServiceTypes( lst.map((item)=>{ item["label"] =  item["name"];return item}))
        
      }
  })
  }
  useEffect(()=>{
    getMasterData()
  },[])
  useEffect(()=>{
    if(loaded_from=="ENQUIRY_UPDATE_STATUS"){
      //getEnquiryDetails()
      let temp_data = {}
      temp_data["applicant_details"] = {
        "first_name":_.get(enquiryData,"name"),
        "last_name":_.get(enquiryData,"name"),
        "email":_.get(enquiryData,"email"),
        "mobile_no":_.get(enquiryData,"mobile_no"),
      };
      setLoanFormDetails({...temp_data})

    }else{
      getLoanApplicationDetails()
    }
   

  },[loanApplicationId, enquiryData]);

  

  
  const [leadSourceList,setLeadSourceList] = useState([])
  const [selectedLeadSource,setSelectedLeadSource] = useState(null)

  const [professionList, setProfessionList] = useState([])
  const [selectedProfession,setSelectedProfession] = useState(null)

  const [professionSubList, setProfessionSubList] = useState([])
  const [selectedSubProfession,setSelectedSubProfession] = useState(null)

  const [serviceTypes,setServiceTypes] = useState([])
  const [selectedServiceType, setSelectedServiceType ]  = useState(null)
  
  const [incomTypeList,setincomTypeList] = useState([])
  const [selectedIncomType, setSelectedIncomType ]  = useState(null)
  const [obligation_list, setObligation_list] = useState([])


  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      date_of_birth: "",
      email: "",
      mobile_no: "",
      alternate_mobile_no: "",
      loanenquired: "",
      loanAmount: "",      
      leadSource: "",

      professionType: "",
      obligations_per_month:'',
      grossSalary:'',
      netSalary:'',
      sepType: "",
      companyName: "",
      Designation: "",
      totalExperience: "",
      present_organization_years: "",
      
      incomeType: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required("First name is required")
        .min(2, "Must be at least 2 characters")
        .max(50, "Must be 50 characters or less"),
      last_name: Yup.string()
        .required("Last name is required")
        .min(1, "Must be at least 1 characters")
        .max(50, "Must be 50 characters or less"),
      date_of_birth: Yup.string().required("Date of birth is required"),
      email: Yup.string()
        .email("Invalid email address")
        // .required("Email is required")
        .min(2, "Must be at least 2 characters")
        .max(50, "Must be 50 characters or less"),
      mobile_no: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
        .min(10, "Must be at least 10 characters")
        .max(15, "Must be 15 characters"),
        alternate_mobile_no: Yup.string().notRequired()
    //       .test('is-valid-mobile', 'Only numbers are allowed, with a minimum of 10 and maximum of 15 characters', function(value) {
    //         const { path, createError } = this;
    //         value = value.trim()
    //         // Check if the value exists
    //         if (value && value.length > 0) {
    //           // If there's a value, run the validation checks
    //           const isValid = /^[0-9 + -]+$/.test(value) && value.length >= 10 && value.length <= 15;
              
    //           if (!isValid) {
    //             return createError({ path, message: "Must be a valid mobile number" });
    //           }
    //         }

    //         // If no value, it's valid (optional field)
    //         return false;
    // })
    ,
      loanenquired: Yup.string().required("Loan enquired is required"),
      loanAmount: Yup.string()
        .required("Loan amount is required")
        .matches(/^\d+$/, "Only numbers are allowed")
        .transform((value) => value.replace(/,/g, "")),
      leadSource: Yup.string().required("Lead source is required"),
      professionType: Yup.string().required("Profession type is required"),
      sepType: Yup.string().when("professionType", {
        is: "SEP",
        then: (schema) => schema.required("Sep type is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      companyName: Yup.string().when("professionType", {
        is: "Salaried",
        then: (schema) => schema.required("Company name is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      designation: Yup.string().when("professionType", {
        is: "Salaried",
        then: (schema) =>
          schema
            .min(2, "Must be at least 2 characters")
            .max(50, "Must be 50 characters or less"),
        otherwise: (schema) => schema.notRequired(),
      }),
      // totalExperience: Yup.string().matches(/^[0-9 .]+$/, "Only numbers are allowed").when("professionType", {
      //   is: "Salaried",
      //   then: (schema) => schema.required("Total experience is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      // present_organization_years:Yup.string().matches(/^[0-9 .]+$/, "Only numbers are allowed").when("professionType", {
      //   is: "Salaried",
      //   then: (schema) => schema.required("Current organization is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

    //   present_organization_years: Yup.string()
    //   .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    //   .when("professionType", {
    //     is: "Salaried",
    //     then: (schema) => schema.required("Current organization is required"),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),
    
    // totalExperience: Yup.string()
    //   .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    //   .test("is-greater", "Total experience must be greater than present organization experience", function(value) {
    //     const { present_organization_years } = this.parent;
    //     // Convert both values to numbers to compare
    //     const totalExp = parseFloat(value);
    //     const presentExp = parseFloat(present_organization_years);
  
    //     if (totalExp && presentExp && totalExp <= presentExp) {
    //       return false; // Validation fails if totalExperience is not greater than present_organization_years
    //     }
    //     return true;
    //   }),

    //grossSalary  netSalary

    grossSalary: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("professionType", {
      is: "Salaried",
      then: (schema) => schema.required("Gross Salary is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("is-greater", "Gross Salary must be greater than Net Salary", function(value) {
      const { netSalary } = this.parent;
      const gross = parseFloat(value); // Gross salary value
      const net = parseFloat(netSalary); // Net salary value

      if (gross && net && gross < net) {
        return false; // Validation fails if grossSalary is not greater than netSalary
      }
      return true;
    }),

  netSalary: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("professionType", {
      is: "Salaried",
      then: (schema) => schema.required("Net Salary is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("is-less-or-equal", "Net Salary must be less than or equal to Gross Salary", function(value) {
      const { grossSalary } = this.parent;
      const net = parseFloat(value); // Net salary value
      const gross = parseFloat(grossSalary); // Gross salary value

      if (net && gross && net > gross) {
        return false; // Validation fails if netSalary is greater than grossSalary
      }
      return true;
    }),

    totalExperience: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("professionType", {
      is: "Salaried",
      then: (schema) => schema.required("Total experience is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("is-greater", "Total experience must be greater than present organization experience", function(value) {
      const { present_organization_years } = this.parent;
      // Convert both values to numbers to compare
      const totalExp = parseFloat(value);
      const presentExp = parseFloat(present_organization_years);

      if (totalExp && presentExp && totalExp <= presentExp) {
        return false; // Validation fails if totalExperience is not greater than present_organization_years
      }
      return true;
    }),

    present_organization_years: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("professionType", {
      is: "Salaried",
      then: (schema) => schema.required("Current organization is required"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("is-less-or-equal", "Present organization experience must be less than or equal to total experience", function(value) {
      const { totalExperience } = this.parent;
      // Convert both values to numbers to compare
      const presentExp = parseFloat(value);
      const totalExp = parseFloat(totalExperience);

      if (presentExp && totalExp && presentExp > totalExp) {
        return false; // Validation fails if present_organization_years is greater than totalExperience
      }
      return true;
    }),

  


      obligations_per_month:Yup.string().matches(/^[0-9 .]+$/, "Only numbers are allowed"),
      //eligible loan_eligible_type fdir loan_eligible_amount
      
    eligible: Yup.string().required("Loan eligiblity is required"),
    loan_eligible_type: Yup.string()
    .when("eligible", {
      is: "Yes",
      then: (schema) => schema.required("Loan eligible type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),   
    proposed_emi: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("eligible", {
      is: "Yes",
      then: (schema) => schema.required("Proposed EMI is required"),
      otherwise: (schema) => schema.notRequired(),
    })    
    .test("is-less-or-equal", "Proposed EMI amount must be less than loan eligible amount", function(value) {
      const { loan_eligible_amount } = this.parent;
      const net = parseFloat(value); // Net salary value
      const gross = parseFloat(loan_eligible_amount); // Gross salary value

      if (net && gross && net > gross) {
        return false; // Validation fails if netSalary is greater than grossSalary
      }
      return true;
    }),

    loan_eligible_amount: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")
    .when("eligible", {
      is: "Yes",
      then: (schema) => schema.required("Loan eligible amount is required"),
      otherwise: (schema) => schema.notRequired(),
    })    
    .test("is-greater", "Loan eligible amount must be greater than Proposed EMI amount", function(value) {
      const { proposed_emi  } = this.parent;
      // Convert both values to numbers to compare
      const totalExp = parseFloat(value);
      const presentExp = parseFloat(proposed_emi);

      if (totalExp && presentExp && totalExp <= presentExp) {
        return false; // Validation fails if totalExperience is not greater than present_organization_years
      }
      return true;
    }),
      fdir: Yup.string().required("Foir is required"),
      
    }),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  // In your input change handler
  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, "");
    const formattedValue = thosuandSeparator(rawValue);
    formik.setFieldValue("loanAmount", e.target.value);
  };

  const [totalOnObligationsAmount, setTotalOnObligationsAmount] = useState(0)
  const [spendingPercentageOnObligations, setPpendingPercentageOnObligations] = useState(0)
  const [totalSalaryNetIncome, setTotalSalaryNetIncome] = useState(0);
  const [totalOtherIncome, setTotalOtherIncome] = useState(0);
  const updatePerMonthObligationAmount = ()=>{
        
        let amount = 0;
        if(formik.values.Obligations == "Yes"){
        if(_.get(obligation_list,"length",0)>0){
          
          obligation_list.forEach((item)=>{
            
            if(_.get(item, "emiAmount")){
              amount = amount+parseFloat(item["emiAmount"])
            }
            
          })
        }
      }
       
        setTotalOnObligationsAmount(amount)
        formik.setFieldValue("obligations_per_month",amount)
      
    

      
  }
   
  useEffect(()=>{
  
  updatePerMonthObligationAmount()
},[obligation_list])

 const calculateSpendingPercentage = ()=>{
      //based on net salary
    // calculateSpendingPercentage
    
   
    if( true || ((totalOtherIncome>0 ||  totalSalaryNetIncome >0)  && totalOnObligationsAmount>0) ){
      
      let total_obgl =totalOnObligationsAmount;
      let proposed_emi = 0 //formik.values.proposed_emi
      if(formik.values.Obligations != "Yes"){
        total_obgl = 0;
      }

      if (formik?.values?.proposed_emi && !isNaN(formik?.values?.proposed_emi) && formik?.values?.proposed_emi > 0) {
        proposed_emi = formik.values.proposed_emi
      }
       
      if(formik.values.eligible != "Yes"){
        proposed_emi =0
      }
      
      if (!isNaN(proposed_emi) && proposed_emi > 0) {
        total_obgl += parseInt(proposed_emi);
    }
      
      
       
        let totalIncome =  totalSalaryNetIncome
        if(formik.values.otherIncome === "Yes"){
          totalIncome =  parseInt(totalSalaryNetIncome)+parseInt(totalOtherIncome)
        }else{
          totalIncome =  totalSalaryNetIncome
        }
        console.log(`totalSalaryNetIncome==${totalSalaryNetIncome} ,totalOtherIncome=${totalOtherIncome} totalOnObligationsAmount=${totalOnObligationsAmount} proposed_emi =${proposed_emi}`)
      //alert("proposed_emi == " +proposed_emi + " total_obgl == "+ total_obgl+" totalIncome = "+totalIncome)
      let spendingPercentage =  (total_obgl/totalIncome)*100;
      console.log(`totalOnObligationsAmount = ${total_obgl}  totalIncome=${totalIncome}`  )
      formik.setFieldValue("fdir", `${!isNaN(spendingPercentage)?Math.floor(Math.min(spendingPercentage, 100),2):0}%`)
     // alert(spendingPercentage)
      setPpendingPercentageOnObligations(spendingPercentage)
      }else{
        setPpendingPercentageOnObligations(0)
        //formik.setFieldValue("fdir", "0 %")
      }
   
 }
 useEffect(()=>{
 
  calculateSpendingPercentage()
 },[totalOnObligationsAmount,totalSalaryNetIncome,totalOtherIncome,proposed_emi]);
 
 
 useEffect(()=>{
  // const [selectedIncomType, setSelectedIncomType ]
  let selectedItem = incomTypeList.find((item)=>loanFormDetails?.income_type_id==item["id"])
  if(_.has(selectedItem,"id")){ 
  setSelectedIncomType(selectedItem);
  formik.setFieldValue("incomeType",selectedItem.name)
  }
 },[incomTypeList,loanFormDetails])

 const setFieldsToNull = ()=>{
  formik.setFieldValue("companyName", "");
  formik.setFieldValue("designation", "");
  formik.setFieldValue("totalExperience", "");
  formik.setFieldValue("present_organization_years", "");
  formik.setFieldValue("grossSalary", "");
  formik.setFieldValue("netSalary", "");
  formik.setFieldValue("workLocation", "");
 }; 
 
 return (
    <div className={`${loanapplicationform}`}>
      
      <Card className="">
        <div className="pt-1">
          {/* First Row */}
          <div className="row">
            <div className="col-md-4 mb-2">
              <FormField
                readOnly
                label="First Name"
                id="first_name"
                name="first_name"
                type="text"
                value={formik.values.first_name}
                onChange={(e) =>
                  formik.setFieldValue("first_name", e.target.value)
                }
                error={formik.touched.first_name && formik.errors.first_name}
                disableNumbers={true}
                disableSymbols={true}
                isImportant={true}
                onBlur={formik.handleBlur}
                focus={formik.values.first_name ? true : false}
              />
              {formik.touched.first_name && (
                <ErrorLabel
                  name="first_name"
                  formik={formik}
                  message={formik.errors.first_name}
                />
              )}
            </div>

            <div className="col-md-4 mb-2">
              <FormField
                readOnly
                label="Last Name"
                id="last_name"
                name="last_name"
                type="text"
                value={formik.values.last_name}
                onChange={(e) =>
                  formik.setFieldValue("last_name", e.target.value)
                }
                error={formik.touched.last_name && formik.errors.last_name}
                disableNumbers={true}
                disableSymbols={true}
                isImportant={true}
                onBlur={formik.handleBlur}
                focus={formik.values.last_name ? true : false }
              />
              {formik.touched.last_name && (
                <ErrorLabel
                  name="last_name"
                  formik={formik}
                  message={formik.errors.last_name}
                />
              )}
            </div>

            {/* New Date of Birth Field */}
            <div className="col-md-4 mb-2">
              {/* <CalendarInput
                label="Age"
                id="date_of_birth"
                name="date_of_birth"
                type="text"
                value={formik.values.date_of_birth}
                onChange={(e) => formik.setFieldValue("date_of_birth", e.target.value)}
                error={formik.touched.date_of_birth && formik.errors.date_of_birth}
                disableNumbers={true}
                disableSymbols={true}
                isImportant={true}
                onBlur={formik.handleBlur}
              />
              <ErrorLabel
                name="date_of_birth"
                formik={formik}
                message={formik.errors.dateOfBirth}
              /> */}
              {
                _.get(loanFormDetails,"applicant_details.date_of_birth",false)&&<FormFieldMail
                readOnly
                label="Date of Birth"
                id="datofbirth"
                name="datofbirth"
                type="txt"
                value={_.get(loanFormDetails,"applicant_details.date_of_birth")}
                
              />
              }
              { !_.get(loanFormDetails,"applicant_details.date_of_birth",false) && <SingleDatePicker
                selectedDate={formik.values.dateOfBirth}
                maxDate={minAge}
                onDateChange={(date) =>{
                  formik.setFieldValue("dateOfBirth", date)
                  formik.setFieldValue("date_of_birth", date)
                }
              }
                label="Date of Birth"
                placeholder="MM/DD/YYYY"
                dateFormat="MM/dd/yyyy"
                datePickerClass={styles.datePickerClass}
              />
               }
               {formik.touched.date_of_birth && (
                <ErrorLabel
                  name="date_of_birth"
                  formik={formik}
                  message={formik.errors.date_of_birth}
                />
              )}
            </div>
          </div>

          {/* Second Row */}
          <div className="row">
            <div className="col-md-4 mb-2">
              <FormFieldMail
                readOnly
                label="Email Address"
                id="email"
                name="email"
                type="email"
                value={formik.values.email}
                onChange={(e) => formik.setFieldValue("email", e.target.value)}
                error={formik?.touched.email && formik.errors.email}
                disableNumbers={false}
                disableSymbols={false}
                isImportant={false}
                onBlur={formik.handleBlur}
                focus={true}
              />
              {formik.touched.email && (
                <ErrorLabel
                  name="email"
                  formik={formik}
                  message={formik.errors.email}
                />
              )}
            </div>

            <div className="col-md-4 mb-2">
              <FormField
                readOnly
                label="Mobile Number"
                id="mobile_no"
                name="mobile_no"
                type="text"
                value={formik.values.mobile_no}
                onChange={(e) =>
                  formik.setFieldValue("mobile_no", e.target.value)
                }
                error={formik.touched.mobile_no && formik.errors.mobile_no}
                disableNumbers={false}
                disableAlphebets={true}
                disableSymbols={true}
                isImportant={true}
                onBlur={formik.handleBlur}
                focus={formik.values.mobile_no ? true : false}
              />
              {formik.touched.mobile_no && (
                <ErrorLabel
                  name="mobile_no"
                  formik={formik}
                  message={formik.errors.mobile_no}
                />
              )}
            </div>

            <div className="col-md-4 mb-2">
              <FormField
                label="Alternate Mobile Number"
                id="alternate_mobile_no"
                name="alternate_mobile_no"
                type="text"
                value={formik.values.alternate_mobile_no}
                onChange={(e) =>
                  formik.setFieldValue("alternate_mobile_no", e.target.value)
                }
                error={
                  formik.touched.alternate_mobile_no &&
                  formik.errors.alternate_mobile_no
                }
                disableNumbers={false}
                disableAlphebets={false}
                disableSymbols={false}
                isImportant={true}
                onBlur={formik.handleBlur}
                focus={formik.values.alternate_mobile_no ? true : false}
              />
              {formik.touched.alternate_mobile_no && (
                <ErrorLabel
                  name="alternate_mobile_no"
                  formik={formik}
                  message={formik.errors.alternate_mobile_no}
                />
              )}
            </div>
          </div>

          {/* Third Row  setSelectedServiceType serviceTypes */}
          <div className="row">
            <div className="col-md-4 mb-2">
            <FormDropdown
                id="loanenquired"
                name="loanenquired"
                label="Loan Enquired"
                options={serviceTypes}
                onChange={(selected) => {
                  
                  setSelectedServiceType(selected)
                  formik.setFieldValue("loanenquired", selected?.label);
                }}
                value={formik.values.loanenquired}
                error={formik.touched.loanenquired && formik.errors.loanenquired}
                onBlur={formik.handleBlur}
                focus={formik.values.loanenquired ? true : false}
              />
              
              {formik.touched.loanenquired && (
                <ErrorLabel
                  name="loanenquired"
                  formik={formik}
                  message={formik.errors.loanenquired}
                />
              )}
            </div>

            <div className="col-md-4 mb-2">
              <FormField
                label="Loan Amount"
                id="loanAmount"
                name="loanAmount"
                type="text"
                value={formik.values.loanAmount}
                onChange={(e) => handleChange(e)}
                error={formik.touched.loanAmount && formik.errors.loanAmount}
                disableNumbers={false}
                disableSymbols={false}
                isImportant={true}
                onBlur={formik.handleBlur}
                focus={formik.values.loanAmount ? true : false}
              />
              {formik.touched.loanAmount && (
                <ErrorLabel
                  name="loanAmount"
                  formik={formik}
                  message={formik.errors.loanAmount}
                />
              )}
            </div>

            <div className="col-md-4 mb-2">
              <FormDropdown
                id="leadSource"
                name="leadSource"
                label="Lead Source"
                options={leadSourceList}
                onChange={(selected) => {
                  console.log("selected", selected);
                  setSelectedLeadSource(selected)
                  formik.setFieldValue("leadSource", selected?.label);
                }}
                value={formik.values.leadSource}
                error={formik.touched.leadSource && formik.errors.leadSource}
                onBlur={formik.handleBlur}
                focus={formik.values.leadSource ? true : false}
              />
              {formik.touched.leadSource && (
                <ErrorLabel
                  name="leadSource"
                  formik={formik}
                  message={formik.errors.leadSource}
                />
              )}
            </div>
          </div>

          {/* Fourth Row for Profession Type */}
          <div className="row">
            <div className="col-md-4 mb-2">
              <FormDropdown
                id="professionType"
                name="professionType"
                label="Profession Type"
                options={professionList}
                onChange={(selected) => {
                  console.log("selected", selected);
                  setSelectedProfession(selected)
                  formik.setFieldValue("professionType", selected?.label);
                  if (selected?.label === "Salaried") {
                    formik.setFieldValue("sepType", "");
                  } else if (selected?.label === "SEP") {
                    setFieldsToNull();
                  }
                  else if (selected?.label === "SENP") {
                    setFieldsToNull();
                  }
                }}
                value={formik?.values?.professionType}
                error={
                  formik.touched.professionType && formik.errors.professionType
                }
                onBlur={formik.handleBlur}
              />
              {formik.touched.professionType && (
                <ErrorLabel
                  name="professionType"
                  formik={formik}
                  message={formik.errors.professionType}
                />
              )}
            </div>

            {(formik.values.professionType === "SEP" || _.get(selectedProfession,"id",null)==3) && (
              <>
              
                <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="sepType"
                    name="sepType"
                    label="Select SEP Type"
                    options={sepTypeOptions}
                    onChange={(selected) =>
                      formik.setFieldValue("sepType", selected?.label)
                    }
                    value={formik?.values?.sepType}
                    error={formik.touched.sepType && formik.errors.sepType}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.sepType && (
                    <ErrorLabel
                      name="sepType"
                      formik={formik}
                      message={formik.errors.sepType}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  {/*  incomTypeList setSelectedIncomType*/}
                  <FormDropdown
                    id="incomeType"
                    name="incomeType"
                    label="Income type"
                    options={incomTypeList}
                    onChange={(selected) =>{
                      setSelectedIncomType(selected)
                      formik.setFieldValue("incomeType", selected?.id)
                    }
                    }
                    value={formik?.values?.incomeType}
                    error={
                      formik.touched.incomeType && formik.errors.incomeType
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.incomeType && (
                    <ErrorLabel
                      name="incomeType"
                      formik={formik}
                      message={formik.errors.incomeType}
                    />
                  )}
                </div>
              </>
            )}

            {(formik.values.professionType === "Salaried" || _.get(selectedProfession,"id",null)==1) && (
              <div className="col-md-12 mb-2">
                <SalariedComponent  formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome}  HBarLabel="Fill the salaried details"  />
              </div>
            )}


            {(formik.values.professionType === "SEP" || _.get(selectedProfession,"id",null)==3) &&
            (formik.values.incomeType === "Salaried" || _.get(selectedIncomType,"id",null)==1) ? (
              <div className="col-md-12 mb-2"> 
                  <SalariedComponent formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome} HBarLabel="Fill the salaried details" />
              </div>
            ) : (formik.values.professionType === "SEP" || _.get(selectedProfession,"id",null)==3) &&
              (formik.values.incomeType === "Business" || _.get(selectedIncomType,"id",null)==2 )  ? (
              <div className="col-md-12 mb-2">
                <SenpComponent formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome} HBarLabel="Fill the business details " />
              </div>
            ) : (
              (formik.values.professionType === "SEP" || _.get(selectedProfession,"id",null)==3) &&
              (formik.values.incomeType === "Both" || _.get(selectedIncomType,"id",null)==3 ) && (
                <>
                  <HBar label="Fill the income details" />
                  <div className="col-md-12 mb-2">
                    
                    <SenpComponent formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome} />
                  </div>
                  <div className="col-md-12 mb-2">
                    <SalariedComponent HBarLabel="Salary details " formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome}/>
                  </div>
                </>
              )
            )}
            {formik.values.professionType === "SENP" && (
              <SenpComponent
                formik={formik}
                HBarLabel="Fill the business details "
                loanFormDetails={loanFormDetails}
                setTotalSalaryNetIncome={setTotalSalaryNetIncome}
                setTotalOtherIncome={setTotalOtherIncome}
              />
            )}
          </div>
          <OtherIncome  formik={formik} loanFormDetails={loanFormDetails} calculateSpendingPercentage={calculateSpendingPercentage} setTotalSalaryNetIncome={setTotalSalaryNetIncome} setTotalOtherIncome={setTotalOtherIncome} HBarLabel="Fill the Other Income Details" />
          
          { <>
            {/* <HBar label={"sfhshsd"} /> */}
            <ObligationsChart loanFormDetails={loanFormDetails} setObligation_list={setObligation_list} formik={formik}  />
          </>
          }

            <HBar label={""} />
            <div className="mb-4">
              <h5 className="mb-3">Monthly Financial Overview</h5>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <div className="bg-light p-3 rounded">
                    <p className="mb-0 text-muted small">Total Income</p>
                    <p className="h4 font-weight-bold text-primary">
                      ₹{thosuandSeparator(
                        Number(formik.values.total_other_income_per_month || 0) + 
                        Number(formik.values.netSalary || 0) + 
                        Number(formik.values.avg_income_per_month || 0)
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 mb-2">
                  <div className="bg-light p-3 rounded">
                    <p className="mb-0 text-muted small">Monthly Obligations</p>
                    <p className="h4 font-weight-bold text-danger">
                      ₹{thosuandSeparator(formik.values.obligations_per_month || 0)}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-2">
              
                <FormDropdown
                  id="eligible"
                  name="eligible"
                  label="Eligible"
                  options={eligibleOptions}
                  onChange={(selected) => {
                    
                    formik.setFieldValue("eligible", selected?.label);
                    if(selected?.label !="Yes"){
                      formik.setFieldValue("loan_eligible_type","");
                      formik.setFieldValue("loan_eligible_amount","" );
                      formik.setFieldValue("fdir","0%" );
                      formik.setFieldValue("proposed_emi",0 );
                      setproposed_emi(0)
                    }
                    
                    
                  }}
                  value={formik?.values?.eligible}
                  error={
                    formik.touched.eligible && formik.errors.eligible
                  }
                  onBlur={formik.handleBlur}
                  isImportant={true}
                  focus={formik.values.eligible? true : false}
                />
                {formik.touched.eligible && (
                  <ErrorLabel
                    name="eligible"
                    formik={formik}
                    message={formik.errors.eligible}
                  />
                )}
              </div>
              <div className="col-md-4 mb-2">
              <FormDropdown
                  id="loan_eligible_type"
                  name="loan_eligible_type"
                  label="Loan Eligible Type"
                  options={serviceTypes}
                  onChange={(selected) => {
                    
                    //setSelectedServiceType(selected) loan_eligible_amount
                    formik.setFieldValue("loan_eligible_type", selected?.id);
                  }}
                  value={formik.values.loan_eligible_type}
                  error={formik.touched.loan_eligible_type && formik.errors.loan_eligible_type}
                  onBlur={formik.handleBlur}
                  focus={formik.values.loan_eligible_type? true : false}
                />
                
                {formik.touched.loan_eligible_type && (
                  <ErrorLabel  name="loan_eligible_type"  formik={formik}  message={formik.errors.loan_eligible_type} />
                )}
              </div>
              <div className="col-md-4 mb-2">
                <FormField
                  label="Loan Eligible Amount"
                  id="loan_eligible_amount"
                  name="loan_eligible_amount"
                  type="text"
                  value={formik.values.loan_eligible_amount}
                  onChange={(e) => {
                    formik.setFieldValue("loan_eligible_amount", e.target.value) 
                  }}
                  error={formik.touched.loan_eligible_amount && formik.errors.loan_eligible_amount}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                  focus={formik.values.loan_eligible_amount? true : false}
                />
                {formik.touched.loan_eligible_amount && (
                  <ErrorLabel name="loan_eligible_amount" formik={formik} message={formik.errors.loan_eligible_amount}  />
                )}
              
              </div>
              <div className="col-md-4 mb-2">
                <FormField
                  label="Proposed EMI"
                  id="proposed_emi"
                  name="proposed_emi"
                  type="text"
                  value={formik.values.proposed_emi}
                  onChange={(e) => {

                    formik.setFieldValue("proposed_emi", e.target.value)
                    setproposed_emi(e.target.value)
                  }}
                  error={formik.touched.proposed_emi && formik.errors.proposed_emi}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                  focus={formik.values.proposed_emi? true : false}
                />
                {formik.touched.proposed_emi && (
                  <ErrorLabel name="proposed_emi" formik={formik} message={formik.errors.proposed_emi}  />
                )}
              
              </div>
              <div className="col-md-4 mb-2">
                <FormField
                  label="FOIR"
                  id="fdir"
                  name="fdir"
                  type="text"
                  //value={formik.values.fdir}
                  value={`${ !isNaN( spendingPercentageOnObligations)?Math.floor(Math.min(spendingPercentageOnObligations, 100),2):0}%`}
                 // value={`${Math.floor(Math.min(spendingPercentageOnObligations, 100),2)}%`}
                  onChange={(e) => {
                    if(!isNaN( e.target.value)){
                    formik.setFieldValue("fdir",`${Math.floor(Math.min( e.target.value, 100),2)}%` ) 
                  }else{
                    formik.setFieldValue("fdir","0%")
                  }
                  }}
                  disabled={true}
                  error={formik.touched.fdir && formik.errors.fdir}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.fdir && (
                  <ErrorLabel name="fdir" formik={formik} message={formik.errors.fdir}  />
                )}
              
              </div>
              </div>
              <div className="row">
              <div className="col-md-6 mb-2">
                <label htmlFor="description">Description</label>
                <textarea  id="description"  name="description" rows="4"  className="form-control"
                    value={formik?.values?.description} // Controlled value from Formik
                    onChange={formik.handleChange} // Formik's handleChange function
                    onBlur={formik.handleBlur} // Formik's handleBlur function
                />
                {formik.touched.description && formik.errors.description && (
                <div className="text-danger">{formik.errors.description}</div> // Display error if any
                )}
              </div>
              
              {!isNaN(spendingPercentageOnObligations) && <>
              {/*&& (formik.values.Obligations == "Yes" || formik.values.Obligations != "Yes")&&*/}
              {/* {spendingPercentageOnObligations} totalSalaryNetIncome=={totalSalaryNetIncome} */}
              <SpeedometerComponent formik={formik}  totalObligationAmount={spendingPercentageOnObligations} MaxSalary={100} />
              </>
            }
            </div>




          
          {/* Submit Button */
          <div className="row justify-content-end w-100">
            
            <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton onClick={()=>{setIsSpinner(false);close_me(0)}} close_me  label="Cancel" className="btn btn-secondary" />
              <PrimaryButton
                type="submit"
                onClick={formik.handleSubmit}
                spinner={isSpinner}
                label="Submit"
                disabled={!(formik.dirty && formik.isValid )}
              />
            </div>
          </div>
          }
          

        </div>
      </Card>
    </div>
  );
}






const eligibleOptions = [
  {
    id: true,
    label: "Yes",
  },
  {
    id: false,
    label: "No",
  },
]
const leadOptions = [
  {
    id: 1,
    label: "TFS Retails",
  },
  {
    id: 2,
    label: "Out Source",
  },
  {
    id: 3,
    label: "Marketing",
  },
  {
    id: 4,
    label: "Agent",
  },
  {
    id: 5,
    label: "Subscribers",
  },
];



const sepTypeOptions = [
  {
    id: 1,
    label: "Doctor",
  },
  {
    id: 2,
    label: "CA",
  },
  {
    id: 3,
    label: "Lawyer",
  },
  {
    id: 4,
    label: "Engineer",
  },
  {
    id: 5,
    label: "Others",
  },
];

